import React from "react";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {useSelector, useDispatch} from "react-redux";

import {toggleModal} from "../../redux/Actions/general.actions";
import {modal, modalCallback} from "../../redux/Selectors/general.selectors";
import Loader from "../Loader";
import ZeusButton from "../Button";

const ConfirmationModal = () => {
  const dispatch = useDispatch();

  const modalData = useSelector(modal);
  const callback = useSelector(modalCallback);

  const _onCloseHandler = () => {
    dispatch(toggleModal({open: false}));
  };

  const _onClickConfirm = () => {
    if (callback) {
      callback();
    }
    dispatch(toggleModal({open: false}));
  };

  return (
    <Modal unmountOnClose={true} isOpen={modalData.open} backdrop={"static"} size={"lg"}>
      <Loader />
      <ModalHeader>{modalData.title}</ModalHeader>
      <ModalBody style={{textAlign: "center"}}>
        <div className="pl-lg-4">{modalData.message}</div>
      </ModalBody>
      <ModalFooter
        className="modalFooter"
        style={{display: "flex", justifyContent: "flex-end"}}
      >
        <ZeusButton onClick={_onCloseHandler} className="info-small">
          Cancel
        </ZeusButton>

        <ZeusButton onClick={_onClickConfirm}>Confirm</ZeusButton>
      </ModalFooter>
    </Modal>
  );
};

ConfirmationModal.propTypes = {};

export default ConfirmationModal;
